import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const mapPhoneLineToApiPhoneLineDto = (values: ICreatePhoneLineForm): IPostNewPhoneLine | {} => {
  let dataMapping: IPostNewPhoneLine;
  const unknown = -1;

    dataMapping = {
      unitID: +values.unitID,
      applProtocolNumber: values.applProtocolNumber,
      applDate: values.applDate,
      offApplDate: values.offApplDate,
      deliveryDate:values.deliveryDate,
      bulkPhoneNumbersAdd: 1,
      comments: values.comments,
      sapCode: values.sapCode,
      phoneNumber: values.phoneNumber,
      lineType: 1,
      isEmporiki:values.isEmporiki,
      isCiti: values.isCiti,
      providerID: +values.providerID !== 0 ? +values.providerID : unknown,
      descline: values.descline
    }

    if (+values.pendingStatusID !== 0) {
      dataMapping.pendingStatusID = +values.pendingStatusID;
    }

    if (+values.usedByID !== 0) {
      dataMapping.usedByID = +values.usedByID;
    }

    if (+values.lineTypeID !== 0) {
      dataMapping.lineTypeID = +values.lineTypeID;
    }

    /* if (+values.providerID !== 0) {
      dataMapping.providerID = +values.providerID;
    } */
  
  return dataMapping;
}


export const createPhoneLine = ({data} : {data: ICreatePhoneLineForm} ): Promise<string> => {
  const phoneLine = mapPhoneLineToApiPhoneLineDto(data);
  return axiosDefaultApi.post(`/api/ComLines/InsertComLine`, phoneLine);
};

type QueryFnType = typeof createPhoneLine;

type UseCreatePhoneLineOptions = {
  data: IPostNewPhoneLine | {};
  config?: MutationConfig<QueryFnType>;
};

export const useCreatePhoneLine = ({ config }: UseCreatePhoneLineOptions) => {
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
        onError: (error: any) => {
            addNotification(`Υπήρξε κάποιο πρόβλημα στην δημιουργία της τηλεφωνικής γραμμής.`, 500);
            console.error('Couldnt create new phone line', error);
            setIsNotificationVisible(true)
          },
          onSuccess: () => {
            queryClient.invalidateQueries(["getAllPhoneLines"])
            addNotification("Δημιουργήθηκε Νέα τηλεφωνική γραμμή.", 200);
            setIsNotificationVisible(true)
            
          },
        ...config,
        mutationFn: createPhoneLine,
    })
}